import { ListItemText } from '@mui/material';
import { MouseEvent } from 'react';
import { ChatMuteType, IChatConversation } from 'src/@types/chat';
import { PATH_DASHBOARD } from 'src/Router/paths';
import { NavActionButton } from 'src/features/Navbar/NavActionButton/NavActionButton';
import { NavItem } from 'src/features/Navbar/NavItem';
import { ChannelAvatar } from 'src/features/channel/ChannelAvatar';
import { ChatNavItemSubChannel } from 'src/sections/@dashboard/chat/ChatNav/ChatNavItemSubChannel';
import {
  ChatDetailsTitle,
  useChatDetailsDialog,
} from 'src/sections/@dashboard/chat/shared/ChatOverviewDialog';

type Props = {
  conversation: IChatConversation;
};

export const ChatNavItemText = ({ conversation }: Props) => {
  const path = PATH_DASHBOARD.chat.view(conversation._id);

  const { showChatDetailsDialog } = useChatDetailsDialog();

  const handleShowDetails = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    showChatDetailsDialog({
      conversationId: conversation._id,
      tab: ChatDetailsTitle.SETTINGS,
    });
  };

  return (
    <>
      <NavItem
        highlight={!!conversation.unreadMessages?.length}
        badgeContent={conversation.unreadMessages?.length}
        depth={1}
        path={path}
        icon={<ChannelAvatar key={conversation._id} channel={conversation} />}
        actionAlwaysVisible
        action={
          <>
            <NavActionButton
              icon="tabler:settings"
              onClick={handleShowDetails}
              size={16}
              color="default"
            />
            {!!conversation.muteSettings?.mute &&
              conversation.muteSettings?.mute !== ChatMuteType.NOTMUTED && (
                <NavActionButton
                  icon="tabler:bell-off"
                  onClick={() => {}}
                  size={16}
                  color="default"
                  actionAlwaysVisible
                />
              )}
          </>
        }
      >
        <ListItemText
          primary={conversation.name}
          sx={{
            m: 0,
          }}
          primaryTypographyProps={{
            noWrap: true,
            variant: 'body2',
          }}
        />
      </NavItem>
      {conversation.subchannels?.map((channel) => (
        <ChatNavItemSubChannel key={channel._id} conversation={channel} />
      ))}
    </>
  );
};
